<template>
  <div class="wrapper">
    <search></search>
    <div class="slide-wrapper">
      <ul>
        <li v-for="(item,index) in slideList" :key="index">
          <div
            v-if="item.child.length !=0"
            class="first-title lengthMax"
            :class="{'first-title-active':item.showFlag ==firstFlag}"
            @click="changeFlag(item.showFlag)"
          >
            {{item.title}}
            <span class="circle"></span>
          </div>
          <div
            v-if="item.child.length ==0"
            class="first-title"
            :class="{'first-title-active':item.showFlag ==firstFlag}"
            @click="changeSecondFlag(item.showFlag,item.type)"
          >
            {{item.title}}
            <span class="circle"></span>
          </div>
          <div class="second-wrapper" v-if="item.showFlag== firstFlag">
            <div class="second-inner">
              <div
                v-for="(childItem,index) in item.child"
                :key="index"
                class="second-title"
                :class="{'second-title-active':childItem.type ==secondFlag}"
                @click="changeSecondFlag(item.showFlag,childItem.type)"
              >
                <div class="second-title-style">
                  {{childItem.title}}
                  <span class="second-circle"></span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.slide-wrapper {
  width: 310px;
  background: #e6ecf2;
  border-radius: 10px;
  padding: 20px 0;
  box-sizing: border-box;
  border: 1px solid #e6ecf2;
}
.first-title {
  width: 310px;
  height: 60px;
  line-height: 20px;
  /* display: table-cell;
  vertical-align: middle; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-bottom: 1px solid #cdd7e2;
  color: #1e4cb0;
  font-size: 18px;
  padding-left: 40px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  background: #f7f7f7;
}
.first-title .circle {
  position: absolute;
  top: 50%;
  left: 16px;
  width: 15px;
  height: 15px;
  transform: translateY(-50%);
  background: #fff;
  border: 3px solid #1e4cb0;
  border-radius: 50%;
  box-sizing: border-box;
}
.first-title-active .circle {
  background: #1e4cb0;
  border: 3px solid #ffffff;
}
/* .first-title-active::after {
  position: absolute;
  content: ">";
  top: 17px;
  right: 10px;
} */

.lengthMax::before {
  position: absolute;
  content: "";
  top: 0;
  right: 20px;
  width: 20px;
  height: 100%;
  background: url(/static/img/title-down-icon.png) no-repeat center center;
  background-size: 14px 10px;
}
.first-title-active::before {
  background: url(/static/img/title-up-icon.png) no-repeat center center !important;
  background-size: 14px 10px;
}

.first-title-active {
  background: url(/static/img/common-nav.png) no-repeat center center;
  background-size: 100% 60px;
  color: #fff;
}
.second-wrapper {
  overflow: hidden;
  transition: height 0.5s ease-in-out;
}
.second-title-active {
  background: #256ec8 !important;
  color: #fff;
}
.second-title .second-circle {
  position: absolute;
  top: 50%;
  left: 19px;
  width: 8px;
  height: 8px;
  transform: translateY(-50%);
  background: #dfdfdf;
  border-radius: 50%;
  box-sizing: border-box;
}
.second-title-active .second-circle {
  background: #fff;
}
.second-title {
  width: 100%;
  height: 60px;
  background: #fff;
  display: table;
  position: relative;
  padding-left: 40px;
  box-sizing: border-box;
  font-size: 16px;
  cursor: pointer;
}
.second-title-style {
  display: table-cell;
  vertical-align: middle;
  line-height: 20px;
  border-bottom: 1px solid #e6ecf2;
  padding-left: 4px;
  box-sizing: border-box;
}
.second-inner .second-title:last-child .second-title-style {
  border-bottom: none;
}
.second-title-active .second-title-style {
  border-bottom: none;
}
</style>

<script>
import { userApi } from "@/api/user.js";
import search from "./../common/search.vue";
export default {
  data() {
    return {
      firstFlag: "0",
      secondFlag: "-1"
    };
  },
  props: ["slideList"],
  methods: {
    changeFlag(showFlag) {
      this.secondFlag = "-1";
      this.firstFlag = showFlag;
    },
    changeSecondFlag(showFlag, type) {
      this.firstFlag = showFlag;
      this.secondFlag = type;
      this.$router.push({
        name: "CooperMajor",
        query: {
          showFlag: showFlag,
          type: type
        }
      });
    },
    // 初始化路由
    handleRoute() {
      this.firstFlag = this.$route.query.showFlag;
      this.secondFlag = this.$route.query.type;
      if (!this.$route.query.showFlag && this.$route.query.showFlag != 0) {
        this.$router.push({
          name: "CooperMajor",
          query: {
            showFlag: 0,
            type: 1
          }
        });
      }
    }
  },
  mounted() {
    this.handleRoute();
  },
  watch: {
    $route() {
      this.handleRoute();
    }
  },
  components: {
    search
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Cooperation/slide.vue